// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"DimensionIcon-primaryButton-3yceLE","dimensionIcon":"DimensionIcon-dimensionIcon-3Hq4oD"};